export default function SectionHeader({ title, description, actions, titleAs: TitleTag = 'h2' }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-x-4 gap-y-3">
      <div className="min-w-0">
        <TitleTag className="text-[17px] leading-6 font-semibold tracking-tight text-gray-900 dark:text-gray-100">{title}</TitleTag>
        {description && <p className="mt-0.5 text-xs text-gray-500 dark:text-gray-400">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
